import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { IRiskPotReportWithRegisteredPreAssessment, IRiskPotAssessment, IRiskPotReportPreAssessment } from "../models/IRiskPotReport";
import { IPage } from "../models/IPage";
import { ICreatePreassessmentModel } from "../models/IPreAssessment";
import { IStandardPhrase } from "../models/IStandardPhrase";
import { objectToQueryString } from "../helpers/ApiHelper";

export class RiskPotReportPreAssessmentApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getRiskPotReports(pagingParameters: IPage, success: (riskPotReports: IPaginatedResponse<IRiskPotReportWithRegisteredPreAssessment[]>) => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(pagingParameters);
        this.getPaginated(`${Utils.LIB_API_BASE_URL}/riskPotReportPreAssessment/preAssessments?${queryString}`, success, error, final);
    }

    savePreAssessmentDecisionComment(data: IRiskPotAssessment, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/riskPotReportPreAssessment/savePreAssessmentDecisionComment`, data, success, error, final);
    }

    closePreAssessment(data: IRiskPotAssessment, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/riskPotReportPreAssessment/close`, data, success, error, final);
    }

    savePreAssessment(data: ICreatePreassessmentModel, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/riskPotReportPreAssessment/preAssessment`, data, success, error, final);
    }

    sendPreAssessment(data: ICreatePreassessmentModel, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/riskPotReportPreAssessment/sendPreAssessment`, data, success, error, final);
    }

    getPreAssessment(preAssessmentId: string, success: (data: IRiskPotReportPreAssessment) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/riskPotReportPreAssessment/preAssessment/${preAssessmentId}`, success, error, final);
    }

    getStandardPhrases(success: (data: IStandardPhrase[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/riskPotReportPreAssessmentDecisionStandardPhrase/standardPhrases`, success, error, final);
    }

    markPreAssessmentDecisionAsRead(preAssessmentId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.put(`${Utils.LIB_API_BASE_URL}/riskPotReportPreAssessment/markPreAssessmentDecisionAsRead/${preAssessmentId}`, undefined, success, error, final);
    }
}

